import { cn } from '@mntn/ui-components'

const sizeVariants = {
  sm: 'h-1',
  md: 'h-2',
  lg: 'h-3',
} as const

export interface ProgressBarProps {
  progress: number
  progressColorClass: string
  /**
   * Controls the height of the progress bar:
   * - sm: 4px (h-1)  [default]
   * - md: 8px (h-2)
   * - lg: 12px (h-3)
   */
  size?: keyof typeof sizeVariants
  containerClassName?: string
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress: percent,
  progressColorClass: bgColorClass,
  size = 'md',
  containerClassName,
}) => {
  return (
    <div className={cn('w-full rounded-full relative overflow-hidden', sizeVariants[size], containerClassName)}>
      <div className={cn('h-full rounded-full relative', bgColorClass)} style={{ width: `${percent}%` }} />
    </div>
  )
}
